<app-header></app-header>

<div class="flex mt-2 h-[calc(100vh-64px)] bg-gray-100">
  <app-sidebar optionMenu="8" class="w-64"></app-sidebar>

  <main class="flex-1 p-6 space-y-6">

    <h1 class="text-2xl font-semibold text-gray-800 flex items-center absolute top-[140px] left-[280px]">
      {{ latestStatus ? 'En vivo' : 'Última Hora' }}
    </h1>

    <div class="text-right">
      <button class="bg-purple-purpleNew text-white font-semibold py-2 px-6 rounded-lg shadow"
        (click)="activarAlerta()">
        Guardar cambios
      </button>
    </div>

    <div class="bg-white shadow rounded-lg p-6">
      <div class="flex flex-wrap items-center justify-between gap-4">
        <div class="flex-1 max-w-[50%] relative">
          <label class="block text-sm font-medium w-full text-gray-700 mb-1">Artículo</label>
          <input type="text" placeholder="Copia y pega el link para agregar" [(ngModel)]="articleUrl"
            class="h-12 mt-1 pl-3 pr-10 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-light-light" />

        </div>

        <button type="button" class="relative right-32 mt-6 text-red-500 hover:text-red-700" aria-label="Eliminar"
          (click)="confirmarEliminar()">🗑️</button>

        <!-- Switch Última Hora / En Vivo -->
        <div class="flex flex-col space-y-4 w-[19%]">
          <div class="flex items-center justify-between">
            <span class="text-sm font-medium">
              Última hora
            </span>
            <label class="inline-flex items-center cursor-pointer mr-2">
              <label class="relative inline-block w-14 h-8 neumorphic-switch">
                <input type="checkbox" class="sr-only peer" [(ngModel)]="latestStatus"
                  (ngModelChange)="changeAlert($event)" />
                <div [ngClass]="!latestStatus ? 'bg-purple-purpleLast' : 'bg-orange-orangeLive'"
                  class="w-16 h-7 rounded-full transition-all duration-300 shadow-inner"></div>
                <div
                  class="absolute top-[2px] left-[2px] w-6 h-6 bg-white rounded-full shadow peer-checked:translate-x-9 transition-all duration-300">
                </div>
              </label>
              <span class="ml-3 text-sm">
                En vivo
              </span>
            </label>
          </div>
        </div>

      </div>
    </div>

    <div class="bg-white shadow rounded-lg p-6">
      <div *ngIf="showBanner"
        class="flex items-center text-white text-sm font-semibold shadow-lg overflow-hidden rounded-lg w-full h-10 mb-4">

        <ng-container *ngIf="latestStatus; else ultimaHora">
          <!-- EN VIVO -->
          <div class="bg-orange-orangeLive flex items-center px-4 h-full w-[176px] flex-shrink-0 rounded-l-[5px] ml-20">
            <div class="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
            <span>EN VIVO</span>
          </div>
        </ng-container>

        <ng-template #ultimaHora>
          <!-- ÚLTIMA HORA -->
          <div class="bg-purple-purpleLast flex items-center px-4 h-full w-[176px] flex-shrink-0 rounded-l-[5px] ml-20">
            <div class="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
            <span>ÚLTIMA HORA</span>
          </div>
        </ng-template>

        <!-- TÍTULO DE LA NOTICIA -->
        <div class="bg-white text-black px-4 w-full h-full flex items-center justify-start overflow-hidden">
          <span class="whitespace-nowrap overflow-hidden text-ellipsis w-full">
            {{ articleTitle }}
          </span>
        </div>
      </div>


      <div class="border border-dashed rounded-lg min-h-[300px] flex items-center justify-center text-sm text-gray-500">
        <img src="https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-dev/RonaldImages/sidebar.png" alt="Apertura Home"
          class="max-h-full max-w-full" />
      </div>

    </div>

  </main>
</div>

<!-- Modal de Éxito -->
<div *ngIf="showSuccessModal" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
  <div class="bg-white rounded-lg p-8 w-[90%] max-w-md text-center shadow-xl">
    <div class="flex justify-center mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M30 59.25C33.8412 59.25 37.6447 58.4934 41.1935 57.0235C44.7423 55.5535 47.9668 53.399 50.6829 50.6829C53.399 47.9668 55.5535 44.7423 57.0235 41.1935C58.4934 37.6447 59.25 33.8412 59.25 30C59.25 26.1588 58.4934 22.3553 57.0235 18.8065C55.5535 15.2577 53.399 12.0332 50.6829 9.31713C47.9668 6.60101 44.7423 4.44647 41.1935 2.97652C37.6447 1.50657 33.8412 0.75 30 0.75C22.2424 0.75 14.8026 3.83169 9.31713 9.31713C3.83169 14.8026 0.75 22.2424 0.75 30C0.75 37.7576 3.83169 45.1974 9.31713 50.6829C14.8026 56.1683 22.2424 59.25 30 59.25ZM29.246 41.83L45.496 22.33L40.504 18.17L26.529 34.9367L19.2977 27.7023L14.7023 32.2977L24.4523 42.0477L26.9678 44.5633L29.246 41.83Z" fill="#3C00A3"/>
      </svg>
    </div>
    <p class="text-lg font-semibold mb-6">
      Cambios generados con éxito
    </p>
    <button (click)="cerrarModalExito()"
      class="bg-purple-purpleNew text-white px-6 py-2 rounded-full font-semibold">
      Volver al inicio
    </button>
  </div>
</div>


<!-- Modal Confirmación de Eliminar -->
<div *ngIf="showDeleteModal" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
  <div class="bg-white rounded-lg p-8 w-[90%] max-w-md text-center shadow-xl">
    <div class="flex justify-center mb-4">
      <svg class="w-12 h-12 text-pink-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01M21 12A9 9 0 1 1 3 12a9 9 0 0 1 18 0Z" />
      </svg>
    </div>
    <p class="text-lg font-semibold mb-6">
      ¿Estás seguro de eliminar la nota?
    </p>
    <div class="flex justify-center gap-4">
      <button (click)="borrarAlertaConfirmada()"
        class="bg-pink-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-pink-600 transition">
        Confirmar
      </button>
      <button (click)="showDeleteModal = false"
        class="border border-gray-300 px-6 py-2 rounded-full text-gray-700 hover:bg-gray-100 transition">
        Cancelar
      </button>
    </div>
  </div>
</div>